module.exports = __webpack_public_path__ + "img/konfigurator-tooltip-spiegel-03.a09de473.jpg";